goog.provide('el8.appchart.actions.allergies');

goog.require('el8.appchart.permissions');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.appchart.mgr.notes');


el8.appchart.actions.allergies = function(opts) {

    opts = opts || {};
    var item = opts.item;
    var menu = [];

    if (el8Globals.TEASE) {
        return [];
    }
    var menu = [];
    if (!item) { // this means we are on a documented-as-none
        var refStr = el8.ptdata.ptAllergies.getDocumentedAsNoneSummary();
        menu.push({
            actionText: 'Export to Note (HPI)',
            actionFn: function() {
                el8.appchart.mgr.notes.addText(refStr, 'problem');
            }
        });
        menu.push({
            actionText: 'Export to Note (ROS)',
            actionFn: function() {
                el8.appchart.mgr.notes.addText(refStr, 'ros');
            }
        });
        menu.push({
            actionText: 'Export to Note (A)',
            actionFn: function() {
                el8.appchart.mgr.notes.addText(refStr, 'assessment');
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                el8.ptdata.ptAllergies.deleteAsDocumented();
            }
        });
        return menu;
    }

    menu.push({
        actionText: 'Edit',
        actionFn: function() {
            el8.appchart.dialog.addEditAllergy.show({'ptAllergy': item});
        }
    });
    if (item.isActive()) {
        menu.push({
            actionText: 'Mark as Inactive',
            actionFn: function() {
                item.setAsInactive();
                el8.ptdata.ptAllergies.saveItem(item, false);
            }
        });
    } else {
        menu.push({
            actionText: 'Mark as Active',
            actionFn: function() {
                item.setAsActive();
                el8.ptdata.ptAllergies.saveItem(item, false);
            }
        });
    }
    menu.push({
        actionText: 'Export to Note (HPI)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
        }
    });
    menu.push({
        actionText: 'Export to Note (ROS)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'ros'});
        }
    });
    menu.push({
        actionText: 'Export to Note (A)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'assessment'});
        }
    });
    menu.push({
        actionText: 'Remove',
        actionFn: function() {
            el8.ptdata.ptAllergies.deleteItem(item);
        }
    });


    return menu;
};
